<template>
    <Labportalen :tab-id="this.tabId" endpoint="/labportalen/webapplication/user/inkorg/" />
</template>

<script>
import BaseTab from "@/tabs/mixins/BaseTab";
import tabIcon from "@/assets/labPortal/inkorg.svg";
import Labportalen from "@/tabs/LabPortalen/Labportalen.vue";

export default {
    components: { Labportalen },
    extends: BaseTab,
    patientBound: false,
    name: "LabPortalenInkorg",
    icon: tabIcon,
    tabName: "Labportalen Inkorg",
    props: ["parameters", "tabId"],
};
</script>
